module.exports = __webpack_public_path__ + "static/productos@2x-5eac32bf3993c0d599b6bc775212d97c.webp";